import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Button,Modal,ModalHeader } from 'reactstrap';
import Table from 'react-bootstrap/Table';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import axios from 'axios'
import * as XLSX from 'xlsx';


export default function Home() {
    const [search, setSearch] = useState('')
    const [claims, setClaims] = useState([])
    const [account, setAccount] = useState('');
    const [type,setType] = useState('')
    const navigate = useNavigate();
    const [modal,setModal] = useState(false)
    const [reg, setReg] = useState('');
    const [driver,setDriver] = useState('');
    const [driverID, setDriverid] = useState('');
    const [place, setPlace] = useState('');
    const [claimant, setClaimant] = useState('');
    const [caseNumber, setCasenumber] = useState('');
    const [lawyer, setLawyer] = useState('');
    const [courtNumber, setCourtnumber] = useState('');
    const [magistrate, setMagistrate] = useState('')
    const [police, setPolice] = useState('')
    const [underwriter1, setUnderwriter1] = useState('')
    const [underwriter2, setUnderwriter2] = useState('')
    const [underwriter3, setUnderwriter3] = useState('')
    const [occurenceDate, setOccurencedate] = useState('')
    const [owner, setOwner] = useState('');
    const [ownerID, setOwnerid] = useState('');
    const [ownerPhone, setOwnerphone] = useState('')
    const [lawyerPhone, setLawyerphone] = useState('');
    const [driverPhone, setDriverphone] = useState('');
    const [policePhone, setPolicephone] = useState('');
    const [claimantPhone, setClaimantphone] = useState('')
    const [claimantID, setClaimantID] = useState('');
    const [claimValue, setClaimvalue] = useState('');
    const [caseProgress, setCaseprogress] = useState('');
    const [award, setAward] = useState('');
    const [auctioneer, setAuctioneer] = useState('')
    const [lawfirm, setLawfirm] = useState('')
    const [proclamation, setProclamation] = useState('')
    const [policyClass, setPolicyclass] = useState("")
    const [policyNumber, setPolicynumber] = useState("")
    const [isOpen, setIsOpen] = useState(false);
    const [attachmentdate, setAttachmentdate] = useState('');
    const [releaseDate, setReleasedate] = useState('')
    const [estimatedLoss, setEstimatedloss] = useState('')
    const [vehicleValue, setVehiclevalue] = useState("")
    const [policeStation, setPolicestation] = useState('');
    const [sellingPrice, setSellingprice] = useState('');
    const [vehicleStatus, setVehiclestatus] = useState('')
    const [loss, setLoss] = useState("")
    const [days, setDays] = useState("")
    const [per, setPer] = useState("")
    const [user, setUser] = useState('')
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const toNew =()=>{
        navigate('/new-claim')
    }
    const toReport =()=>{
        navigate('/report')
    }
    const toIndividual =()=>{
        navigate('/individual-report')
    }
    const toUsers =()=>{
        navigate('/users')
    }

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };


    const toggle =async(e)=>{
        const id = e.target.value;
        const res = await fetch(`https://panel.yunshuglobal.com:3063/api/getThisClaim?id=${id}`);
        const data = await res.json();
        setReg(data.Registration);
        setDriver(data.Driver);
        setDriverid(data.Driverid);
        setPlace(data.Place);
        setClaimant(data.Claimant);
        setOccurencedate(new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(data.OccurenceDate));
        setPolice(data.Police);
        setCasenumber(data.CaseNumber);
        setLawyer(data.Lawyer);
        setCourtnumber(data.CourtNumber);
        setMagistrate(data.Magistrate);
        setUnderwriter1(data.Underwriter1);
        setUnderwriter2(data.Underwriter2);
        setUnderwriter3(data.Underwriter3);
        setLawfirm(data.lawfirm);
        setDriverphone(data.driverPhone);
        setOwner(data.owner);
        setOwnerid(data.ownerID);
        setOwnerphone(data.ownerPhone);
        setLawyerphone(data.lawyerPhone);
        setPolicephone(data.policePhone);
        setClaimantID(data.claimantID);
        setClaimantphone(data.claimantPhone);
        setClaimvalue(data.claimValue);
        setCaseprogress(data.caseStage);
        setAward(data.award);
        setProclamation(data.proclamation)
        setAuctioneer(data.auctioneer)
        setPolicyclass(data.policyClass);
        setPolicynumber(data.policyNumber);
        setAttachmentdate(data.AttachmentDate);
        setReleasedate(data.ReleaseDate)
        setEstimatedloss(data.EstimatedLoss);
        setVehiclevalue(data.VehicleValue);
        setSellingprice(data.SellingPrice);
        setVehiclestatus(data.VehicleStatus);
        setPolicestation(data.PoliceStation);
        setPer((data.ReleaseDate) - (data.AttachmentDate));
        setUser(data.User)

        const response = await axios.get('https://panel.yunshuglobal.com:3063/api/user-files', {
            params: { email:data.User }
        });
        setFiles(response.data);

        
        const day = convertMillisecondsToDays((data.ReleaseDate) - (data.AttachmentDate));
        const number = parseInt(estimatedLoss.replace(/,/g, ''), 10);
        const l = number * day;
        setLoss(l)
        setDays(day);

        
        

        setModal(!modal)
        
    }

    useEffect(() => {
        const user = localStorage.getItem('email'); // Retrieve email
        if (user) {
          setAccount(user)
        } else {
       
        }
      }, []);

      useEffect(()=>{

        const getType =async()=>{
            const res = await fetch(`https://panel.yunshuglobal.com:3063/api/getType?email=${account}`);
            const data = await res.json();
            setType(data.IsAdmin)
        }

        if(account){
            getType()
        }

      },[account])

      useEffect(()=>{

        const getClaims =async()=>{
            const res = await fetch(`https://panel.yunshuglobal.com:3063/api/getClaims?account=${account}`);
            const data = await res.json();
            setClaims(data)
        }

        const getAllClaims =async()=>{
            const res = await fetch(`https://panel.yunshuglobal.com:3063/api/getAllClaims`);
            const data = await res.json();
            setClaims(data)
        }

        

        
        if(account){

            if(type == '0'){
                getClaims();
            }
            else if(type == '1'){
                getAllClaims();
            }
            else if(type == '3'){
                getAllClaims();
            }
           
        }

      },[account,type])

      useEffect(()=>{
        const searchResults =async()=>{
            const res = await fetch(`https://panel.yunshuglobal.com:3063/api/searchClaim?search=${search}`);
            const data = await res.json();
            setClaims(data)
        }
        if(search){
            searchResults()
        }

      },[search])

      const logout=()=>{
        localStorage.removeItem('email');
        navigate('/login')
      }

      const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const convertMillisecondsToDays = (milliseconds) => {
    // Convert milliseconds to days
    const msInDay = 1000 * 60 * 60 * 24; // Milliseconds in a day
    return Math.floor(milliseconds / msInDay); // Divide and round down to get full days
  };

//   useEffect(()=>{
//     if(attachmentdate && releaseDate){
//         const period = releaseDate - attachmentdate;
//         const day = convertMillisecondsToDays(period);
//         const number = parseInt(estimatedLoss.replace(/,/g, ''), 10);
//         const l = number * day;
//         setLoss(l)
//         setDays(day);
//     }

//   },[attachmentdate, releaseDate])

  const calcDates =()=>{
    const period = releaseDate - attachmentdate;
    setPer(period)
    const day = convertMillisecondsToDays(period);
    const number = parseInt(estimatedLoss.replace(/,/g, ''), 10);
    const l = number * day;
    setLoss(l)
    setDays(day);

  }

  const formatCurrency = (value) => {
    // Format the number with commas and the currency symbol (KES in this case)
    return new Intl.NumberFormat('en-Kenya', {
      style: 'currency',
      currency: 'KES',
    }).format(value);
  };

      const exportToPdf = () => {
          const doc = new jsPDF();
      
          // Add a title to the PDF
          doc.text("MOTOR CLAIMS CLAIMS REPORT", 20, 10);
      
          // Extract table headers and rows from the DOM
          const table = document.getElementById("dataTable");
          const headers = Array.from(
            table.querySelectorAll("thead tr th")
          ).map((header) => header.textContent);
      
          const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
            Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
          );
      
          // Generate the PDF table
          doc.autoTable({
            head: [headers],
            body: rows,
            startY: 20,
          });
      
          // Save the PDF
          doc.save("MOTOR_CLAIMS_REPORT.pdf");
        };

        const exportToExcel = () => {
  // Get the table element
  const table = document.getElementById("dataTable");
  
  // Extract headers
  const headers = Array.from(table.querySelectorAll("thead tr th")).map(
    (header) => header.textContent
  );

  // Extract rows
  const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
    Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
  );

  // Create a workbook
  const wb = XLSX.utils.book_new();
  
  // Convert data to worksheet
  const wsData = [headers, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, "Motor Claims Report");

  // Generate and save the Excel file
  XLSX.writeFile(wb, "MOTOR_CLAIMS_REPORT.xlsx");
};


  return (
    <div>
        <div className="homeTop">
            <div className="menuBar">
                <h4 className='menuTitle'>Motor Claims Database</h4>

                {type == '0' &&
                    <div className="menuList">
              
                        <p className='menu'>My Claims</p>
                        <p className='menu' onClick={toNew}>New Claim</p>
                        <p className='menu' onClick={toReport}>Reports</p>
                        <p className='menu' onClick={logout}>Sign Out</p>
                        
                    </div>
                
                }
                {type == '1' &&
                    <div className="menuList">
              
                        <p className='menu'>My Claims</p>
                        <p className='menu' onClick={toUsers}>Users</p>
                        <p className='menu' onClick={toIndividual}>Individual Reports</p>
                        <p className='menu' onClick={toReport}>Reports</p>
                        <p className='menu' onClick={logout}>Sign Out</p>
                        
                    </div>
                
                }
                {type == '3' &&
                    <div className="menuList">
              
                        <p className='menu'>All Claims</p>
                       
                        <p className='menu' onClick={toReport}>Reports</p>
                        <p className='menu' onClick={logout}>Sign Out</p>
                        
                    </div>
                
                }
                
                
                <div className="phoneMenu">
                    <header className='header'>
                        <div className="menu-icon" onClick={toggleMenu}>
                        <span className="bar"></span>
                        <span className="bar"></span>
                        <span className="bar"></span>
                        </div>

                        <nav className={`nav-menu ${isOpen ? 'open' : ''}`}>
                        <ul>
                            <li ><a href="/">My Claims</a></li>
                            <li onClick={toNew}><a>New Claim</a></li>
                            <li  onClick={toReport}><a>Reports</a></li>
                            <li onClick={logout}><a>Sign Out</a></li>
                        </ul>
                        </nav>
                    </header>
                </div>
            </div>
            <div className="searchContainer">
                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Search" onChange={(e)=>{setSearch(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={search}  type="text" placeholder="Search" />
                </FloatingLabel>
                <Button color='info' className='searchButton' >SEARCH</Button>

            </div>

            <div className="paymentDetails">
            <div className="mpesaDetails">
                <img src="/mpesa.webp" alt=""  className='mpesaLogo'/>
                <p >PAYBILL: 247 247</p>
                <p>Account No: 667899</p>
                <hr />
                <p>Individual Owner: Kes. 20,000 /=</p>
          


                </div>
            </div>
         

        </div>
        <div className="homeContainer">
                {type== '0' &&
                <div className="newClaim">
                
                    <Button color='success' onClick={toNew}>Register new claim</Button>
               
                </div>
                
                }
            
            <hr />
            <h6 style={{marginTop:'1%'}}>All claims({claims.length})</h6>

            {type == '0' &&
                <div className="table-responsive" id="dataTable">
                <Table striped bordered hover>

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Date</th>
                            <th scope="col">Registration number</th>
                            <th scope="col">Underwriter</th>
                            <th scope="col">Place</th>
                            <th scope="col">Claimant</th>
                            <th scope="col">Action</th>

                         
                        </tr>
                    </thead>
                    <tbody>
                        {claims.map((val,index)=>{
                            const policyDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.OccurenceDate)
                           
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} onClick={toggle} >{val.Registration}</button></td>
                                    <td>{val.Underwriter1}</td>
                               
                                    <td>{val.Place}</td>
                                    <td>{val.Claimant}</td>
                                    <td><button value={val.Id} onClick={toggle} style={{border:'none',backgroundColor:'green',color:'white'}}>View</button></td>
                                   
                                    

                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
                <div className="mobilePayment">
                <div className="mpesaDetails">
                <img src="/mpesa.webp" alt=""  className='mpesaLogo'/>
                <p >PAYBILL: 247 247</p>
                <p>Account No: 667899</p>
                <hr />
                <p>Individual Owner: Kes. 10,000 /=</p>
           


                </div>

                </div>
               
            </div>
            
            
            }
            {type == '1' &&
                <div className="table-responsive">
                <Button color='success' onClick={exportToExcel} style={{marginBottom:'1%'}}>Export as CSV</Button>
                <Table striped bordered hover id="dataTable">

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Account</th>
                            <th scope="col">Case Number</th>
                            <th scope="col">Registration number</th>
                            <th scope="col">Underwriter</th>
                            <th scope="col">Place</th>
                            <th scope="col">Claimant</th>
                         
                        </tr>
                    </thead>
                    <tbody>
                        {claims.map((val,index)=>{
                            const policyDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.OccurenceDate)
                           
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{val.FirstName} {val.Surname}</td>
                                    <td>{val.CaseNumber}</td>
                                    <td><button  className='tableButton' value={val.Id} onClick={toggle} >{val.Registration}</button></td>
                                    <td>{val.Underwriter1}</td>
                               
                                    <td>{val.Place}</td>
                                    <td>{val.Claimant}</td>
                                   
                                    

                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>
            
            
            }

            {type == '3' &&
                <div className="table-responsive">
                <Button color='success' onClick={exportToExcel} style={{marginBottom:'1%'}}>Export as CSV</Button>
                <Table striped bordered hover id="dataTable">

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Account</th>
                            <th scope="col">Date</th>
                            <th scope="col">Registration number</th>
                            <th scope="col">Underwriter</th>
                            <th scope="col">Place</th>
                            <th scope="col">Claimant</th>
                         
                        </tr>
                    </thead>
                    <tbody>
                        {claims.map((val,index)=>{
                            const policyDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.OccurenceDate)
                           
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td><button  className='tableButton' value={val.Id} onClick={toggle} >{val.FirstName} {val.Surname}</button></td>
                                    <td>{val.CaseNumber}</td>
                                    <td><button  className='tableButton' value={val.Id} onClick={toggle} >{val.Registration}</button></td>
                                    <td>{val.Underwriter1}</td>
                               
                                    <td>{val.Place}</td>
                                    <td>{val.Claimant}</td>
                                   
                                    

                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>
            
            
            }
            

        </div>

        <Modal isOpen={modal} toggle={toggle} size='lg'>
            <ModalHeader>Vehicle: {reg}</ModalHeader>
            <div className="modalContainer">
            <div className="modalBody">
                    <div className="modalB">
                        
                        <h6>Basic information</h6>
                        <p>Vehicle registration: {reg}</p>
                        <p>Vehicle Owner: {owner}</p>
                        <p>Owner ID: {ownerID}</p>
                        <p>Owner phone number: {ownerPhone}</p>
                        <p>Driver's name: {driver}</p>
                        <p>Driver phone number: {driverPhone}</p>
                        <p>Driver ID: {driverID}</p>
                        <p>Location of incident: {place}</p>
                        <p>Claimant's name: {claimant}</p>
                        <p>Claimant phone: {claimantPhone}</p>
                        <p>Claimant ID: {claimantID}</p>
                        <p>Claim value: Kes. Kes {claimValue}</p>
                        <p>Police Station: {policeStation}</p>
                    </div>
                 
                     <div className="modalB">
                        <h6>Litigation/Court Process</h6>
                        <p>Police officer: {police}</p>
                        <p>Police phone number: {policePhone}</p>
                        <p>Case number : {caseNumber}</p>
                        <p>Law firm: {lawfirm}</p>
                        <p>Lawyer's name: {lawyer}</p>
                        <p>Lawyer phone number: {lawyerPhone}</p>
                        <p>Court number: {courtNumber}</p>
                        <p>Magistrate's name: {magistrate}</p>
                        <p>Case stage: {caseProgress}</p>
                        <p>Value of the vehicle: Kes {vehicleValue}</p>
                        <p>Auction Value: Kes {sellingPrice} </p>
                        {vehicleStatus == '1' &&
                            <p>Vehicle status: Sold</p>
                        }
                         {vehicleStatus == '0' &&
                            <p>Vehicle status: Not Sold</p>
                        }

                        <p>Attachment Date: {new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(attachmentdate)}</p>
                        <p>Release Date: {new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(releaseDate)}</p>
                        <p>Days at the yard: {days}</p>
                        <p>Estimated loss: {formatCurrency(loss)}</p>
                        {caseProgress == 'Judgement' && 
                        <>
                            <p>Award: Kes. {award}</p>
                            <p>Proclamation: {proclamation}</p>
                            <p>Attached Auctioneer: {auctioneer}</p>


                        </>
                        
                        }
                        
                    </div>

                    

                    <div className="modalB">
                        <h6>Underwriter information</h6>
                        <p>Policy class: {policyClass}</p>
                        <p>Policy number: {policyNumber}</p>
                        <p>Insurance Company: {underwriter1}</p>

                       
                    </div>
                   
                </div>
                <div className="user-files-container">
            <h4>Documents</h4>
            <div className="files-list">
                {files.map((file, index) => (
                    <div key={index} className="file-item">
                        <div className="file-name">
                            <a 
                                href={file.path} 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                {file.name}
                            </a>
                        </div>
                        {/* <div className="file-details">
                            <span>Size: {formatFileSize(file.size)}</span>
                            <span>Last modified: {new Date(file.lastModified).toLocaleString()}</span>
                        </div> */}
                    </div>
                ))}
            </div>
        </div>
              
                <Button color='danger' onClick={()=>{setModal(false)}} style={{marginLeft:'2%',marginTop:'3%'}}>Close</Button>


            </div>
        </Modal>
    </div>
  )
}
